const renderFormat = Object.freeze({
  SCREENSHOT: 'Image',
  PDF: 'PDF',
});

export default renderFormat;
